<template>
  <v-main>
    <v-container id="container" fluid pa-0>
      <transition name="component-fade" mode="out-in">
        <keep-alive>
          <router-view/>
        </keep-alive>
      </transition>
    </v-container>
  </v-main>
</template>

<script>

export default {
  data: () => ({
  }),
  components: {
  },
  props: {
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>
  #container { /* Scroll container en vez de pagina entera */
    overflow-y: auto !important;
    height: calc(100vh - 64px);
  }

  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
  }
  .component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
